import { useEffect, useState } from "react";
import client from "@/lib/glossyApi";
import { MessageSquareQuote, ChevronDown, ChevronUp } from "lucide-react";
import MemberArticlePanel from "./MemberArticlePanel";

/** 5 Questions — the interview piece. Reads/writes the exact article Master Build creates. */
export default function FiveQuestionsSection({ member, article, onArticleChange }) {
  const [questions, setQuestions] = useState([]);
  const [open, setOpen] = useState(false);
  const answers = member?.interview_answers || {};
  const answered = Object.values(answers).filter((v) => String(v || "").trim()).length;

  useEffect(() => {
    client.get("/members/me/interview-questions").then((r) => setQuestions(r.data.questions || [])).catch(() => {});
  }, []);

  return (
    <>
      <MemberArticlePanel
        member={member} article={article} onArticleChange={onArticleChange}
        kind="five_questions" sectionId="section-fiveq" tid="fiveq"
        heading="5 Questions" note="the interview"
        publicNote="Publish Now sends this live to the magazine under 5 Questions."
      />
      <div className="mb-8 -mt-6 border border-ink/15 border-t-0 bg-white" data-testid="fiveq-real-answers">
        <button onClick={() => setOpen(!open)} className="w-full p-4 flex items-center justify-between gap-3 hover:bg-secondary/40 transition-colors" data-testid="fiveq-answers-toggle">
          <p className="overline text-[10px] text-ink/60 flex items-center gap-2">
            <MessageSquareQuote size={12} />
            Their real answers — the interview's source
            <span className={`px-2 py-0.5 text-[9px] ${answered > 0 ? "bg-green-100 text-green-800" : "bg-amber-100 text-amber-800"}`}>
              {answered > 0 ? `${answered} of ${questions.length || 10} answered` : "NOT ANSWERED YET"}
            </span>
          </p>
          {open ? <ChevronUp size={14} className="text-ink/40" /> : <ChevronDown size={14} className="text-ink/40" />}
        </button>
        {open && (
          <div className="px-4 pb-4 space-y-3" data-testid="fiveq-answers-list">
            {answered === 0 && (
              <p className="font-sans text-xs text-amber-700">
                They haven't filled their interview form in yet — until they do, the piece is ghost-written from their Master brief and website (facts only, nothing invented). Once their answers land, redraft and it rebuilds from their real words.
              </p>
            )}
            {questions.map((q, i) => {
              const a = answers[String(i)] || answers[i] || "";
              return (
                <div key={i} data-testid={`fiveq-answer-${i}`}>
                  <p className="font-sans text-xs font-semibold text-ink">{i + 1}. {q}</p>
                  <p className={`font-sans text-sm mt-0.5 ${a ? "text-ink/75" : "text-ink/30 italic"}`}>{a || "No answer given"}</p>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </>
  );
}
